import {listingItemLabel, listingItemType} from '@/constants/listingItemTypes';

type YearMakeModelListing = {
    item_type?: string | null;
    item_label?: string | null;
    vehicle?: { year?: number | string | null; make?: string | null; model?: string | null } | null;
} | null | undefined;

const isVehicleListing = (listing: YearMakeModelListing): boolean => !listing?.item_type || listing.item_type === 'vehicle';

/** "2021 Toyota Camry", or '' when none of the three are set. */
export function listingYearMakeModel(listing: YearMakeModelListing): string {
    return [listing?.vehicle?.year, listing?.vehicle?.make, listing?.vehicle?.model].filter(Boolean).join(' ');
}

/**
 * A listing's one-line subtitle on fleet screens: year/make/model when set,
 * otherwise what it is ("Horse trailer", "Equipment") for non-vehicles. Cars
 * without year/make/model stay blank, as before. See docs/non-vehicle-listings.md §6.
 */
export function listingYearMakeModelOrItemLabel(listing: YearMakeModelListing): string {
    const yearMakeModel = listingYearMakeModel(listing);

    if (yearMakeModel || isVehicleListing(listing)) {
        return yearMakeModel;
    }

    return listingItemLabel(listing);
}

/**
 * Whether Year/Make/Model filters make sense for a fleet: any listing whose type
 * needs them (cars), or any listing that has them filled in anyway.
 */
export function fleetHasYearMakeModel(listings: YearMakeModelListing[]): boolean {
    return listings.some((listing) => listingItemType(listing).requiresYearMakeModel || listingYearMakeModel(listing) !== '');
}
